import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"#000"} }, [
  /*#__PURE__*/_createElementVNode("span", null, " 导入“国家/地区”数据 ")
], -1)
const _hoisted_2 = { "element-loading-text": "正在保存数据，请稍后" }
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 选择文件 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确 定")

import { reactive, h } from 'vue';
import * as xlsx from "xlsx";
import { NationImportApi } from '../../../../apis/basics/nation.api';
import { ElMessage } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  emits: ['onSaveSuccess'],
  setup(__props, { expose, emit: $emits }) {

const continentMap = new Map();
continentMap.set("亚洲", "1")
continentMap.set("欧洲", "2")
continentMap.set("北美洲", "3")
continentMap.set("南美洲", "4")
continentMap.set("非洲", "5")
continentMap.set("大洋洲", "6")
continentMap.set("南极洲", "7")



const state = reactive({
    loading: false,
    fileList: [] as any[],
    tableData: [] as any[],
    showDialog: false,
})

const actions = {
    /* 读取Excel文件 */
    readFile: (file: File) => {
        return new Promise(resolve => {
            let reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = ev => {
                resolve(ev.target?.result);
            }
        });
    },
    /* 读取Excel文件内容 */
    readExcelFile: async (file: File, sheetIndex: number) => {
        let data = await actions.readFile(file);
        let workbook = xlsx.read(data, { type: 'binary' });

        let worksheet = workbook.Sheets[workbook.SheetNames[sheetIndex]];
        data = xlsx.utils.sheet_to_json(worksheet);

        const _data = JSON.parse(JSON.stringify(data));
        const _json = [] as any;

        _data.forEach((item: any) => {
            const continentStr = (item.所属大洲 ?? '') + '';
            _json.push({
                nation_name_cn: (item.国家或地区 ?? '') + '',
                nation_name_en: (item.英文名 ?? '') + '',
                nation_full_name: (item.全称 ?? '') + '',
                nation_iso_code: (item.ISO3166_1三位字母代码 ?? '') + '',
                nation_code: (item.国家代码 ?? '') + '',
                continent: continentMap.get(continentStr) ?? "9"
            });
        });

        return _json;
    },
    uploadChange: async (options: any) => {
        state.loading = true
        const data = await actions.readExcelFile(options.raw, 0);
        state.tableData = data;
        state.loading = false
    },
    getElTagDic: (item: any) => {
        const continentDic = new Map();
        continentDic.set("1", "亚洲")
        continentDic.set("2", "欧洲")
        continentDic.set("3", "北美洲")
        continentDic.set("4", "南美洲")
        continentDic.set("5", "非洲")
        continentDic.set("6", "大洋洲")
        continentDic.set("7", "南极洲")
        continentDic.set("9", "其他")

        return continentDic.get(item.continent) ?? "N/A";
    },
    save: async () => {

        state.loading = true;
        const nationList = state.tableData;

        const onSuccess = ((res: any) => {
            const { succeeded, errors } = res
            if (!succeeded) {
                ElMessage.error(errors)
            } else {
                ElMessage.success('导入成功')
                state.showDialog = false;
            }
        });

        const onError = ((err: any) => {
            ElMessage.error(err.message);
        })

        const onFinally = () => {
            $emits('onSaveSuccess')
            state.loading = false;
        }

        await NationImportApi(nationList).then(onSuccess).catch(onError).finally(onFinally);
    }
}

const expFuncs = {
    openDialog: () => {
        state.fileList = [];
        state.tableData = [];
        state.showDialog = true;
    }
}

expose({ ...expFuncs })


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(state).showDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).showDialog) = $event)),
    size: "small",
    width: 1000
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_el_button, {
          disabled: _unref(state).loading,
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_upload, {
              ref: "uploadRef",
              "file-list": _unref(state).fileList,
              "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).fileList) = $event)),
              limit: 1,
              action: "",
              "show-file-list": false,
              "auto-upload": false,
              "on-change": actions.uploadChange,
              accept: "xlsx,xls"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["file-list", "on-change"])
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          disabled: _unref(state).loading,
          size: "small",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).showDialog = false))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          disabled: _unref(state).loading,
          size: "small",
          type: "primary",
          onClick: actions.save
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_el_table, {
          size: "small",
          data: _unref(state).tableData,
          style: {"width":"100%"},
          "row-key": "id",
          border: "",
          height: "500"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "55",
              fixed: "",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "nation_code",
              label: "国家代码",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "nation_name_cn",
              label: "国家名称(中文)",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "nation_name_en",
              label: "国家名称(英文)",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "nation_full_name",
              label: "全称",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "nation_iso_code",
              label: "ISO3186",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "continent",
              label: "所属大陆",
              "min-width": "100",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_tag, { type: "primary" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(actions.getElTagDic(scope.row)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})